import Home from "./components/home/Home";

export default function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}